<template>
  <v-container fluid class="d-flex align-center justify-center">
    <v-layout class="d-flex align-center justify-center">
      <div class="wid-100">
        <v-row dense align="center">

          <v-col cols="2" >
            <div class="pt-0">
              <span>이용약관</span>
            </div>
          </v-col>
          <v-col cols="8">
            <tiny-editor ref="terms_cn" @input="itemChanged"></tiny-editor>
          </v-col>
          <v-col cols="12"><v-divider></v-divider></v-col>
          <v-col cols="2" >
            <div class="pt-0">
              <span>개인정보처리방침</span>
            </div>
          </v-col>
          <v-col cols="8">
            <tiny-editor ref="prvcy_polcy_cn" @input="itemChanged"></tiny-editor>
          </v-col>
          <v-col cols="12"><v-divider></v-divider></v-col>
          <v-col cols="2" >
            <div class="pt-0">
              <span>이메일 무단 수집 거부</span>
            </div>
          </v-col>
          <v-col cols="8">
            <tiny-editor ref="email_colct_deny_cn" @input="itemChanged"></tiny-editor>
          </v-col>
          <v-col cols="12"><v-divider></v-divider></v-col>
        </v-row>  
      </div>
    </v-layout>
  </v-container>
      
  
</template>

<script>
import tinyEditor from '@/components/common/tinyEditor.vue';

export default {
  components: { tinyEditor },
  data(){
    return{
      mberSno: "",

      isNew: false,              // 조회된 값이 있으면 false
      // terms: "",                // 이용약관
      // prvcy_polcy: "",          // 개인정보처리방침
      // email_colct_deny: "",  // 이메일 무단수집 거부
    }
  },
  created() {
    this.mberSno = this.$session.get("mberSno");

    this.getSoctyGenPolcy();
  },
  methods: {
    getSoctyGenPolcy() {
      const params = new FormData();

			this.$http.post("/admin/getSoctyGenPolcy", params).then((res) => {
        // console.log("res.data: ", res.data.result.length);
        if(res.data.result.length == 0) {
          this.isNew = true;
          // alert("조회된 정보가 없습니다.");
          return;
        } else {
          this.isNew = false;
        }

        const polcy = res.data.result[0];

        this.$refs.terms_cn.content = polcy.terms;
        this.$refs.prvcy_polcy_cn.content = polcy.prvcy_polcy;
        this.$refs.email_colct_deny_cn.content = polcy.email_colct_deny;
			}).catch(function (error) {
					console.log(error);
				}
			);
    },
    saveBtnClicked() {
      console.log("saveSoctyGenPolcy");

      // if(confirm("저장하시겠습니까?")) {
        const params = new FormData();

        params.append("mber_sno", this.mberSno);
        params.append('new_yn', this.isNew ? 'Y' : 'N');

        if(this.$refs.terms_cn.content != null) {
          params.append("terms", this.$refs.terms_cn.content);
        }

        if(this.$refs.prvcy_polcy_cn.content != null) {
          params.append("prvcy_polcy", this.$refs.prvcy_polcy_cn.content);
        }

        if(this.$refs.email_colct_deny_cn.content != null) {
          params.append("email_colct_deny", this.$refs.email_colct_deny_cn.content);
        }

        this.$http.post("/admin/upsertSoctyGenPolcy", params).then((res) => {
          console.log(res.data);
          // alert("저장되었습니다.");
          
          this.getSoctyGenPolcy();
        })
        .catch(function (error) {
            console.log(error);
          }
        );
      // }
    },
    itemChanged() {
      console.log("itemChanged");
      this.$emit('tabChanged', 'generalPolicyTab');
    },
  },
}
</script>

<style>

</style>